'use client';

import { useEffect, useState, type ComponentPropsWithoutRef } from 'react';
import { THEME_CHANGE_EVENT, withThemeQuery } from '@/lib/themeSync';

type Props = Omit<ComponentPropsWithoutRef<'a'>, 'href'> & { href: string };

/**
 * Laravel lives on another origin in dev; `localStorage` is not shared.
 * Keeps `href` in sync with the current theme query param for navigation and open-in-new-tab.
 */
export function ThemedExternalLink({ href, ...rest }: Props) {
  const [resolved, setResolved] = useState(href);

  useEffect(() => {
    const sync = () => setResolved(withThemeQuery(href));
    sync();
    window.addEventListener(THEME_CHANGE_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(THEME_CHANGE_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, [href]);

  return <a href={resolved} {...rest} />;
}
